import { IRestaurant } from '@rbi-ctg/store';
import { useGetRestaurantQuery } from 'generated/graphql-gateway';
import logger from 'utils/logger';

import { useGetStoreAvailabilityFn } from './use-get-restaurant-availability-fn';

interface IUseRestaurantPosConnectivityStatus {
  storeId: string | null;
  pollInterval?: number;
  skip?: boolean;
}

export const useStorePosConnectivityStatus = ({
  storeId,
  pollInterval,
  skip = false,
}: IUseRestaurantPosConnectivityStatus) => {
  const checkAvailability = useGetStoreAvailabilityFn();

  const { data, loading, refetch } = useGetRestaurantQuery({
    fetchPolicy: 'cache-and-network',
    variables: { storeId },
    skip: !storeId || skip,
    // skip does not apply to polling calls
    // if storeId is cleared, then we set the interval to 0 which ends the polling
    pollInterval: storeId ? pollInterval : 0,
    onError: err =>
      logger.warn({ err, message: `Failed to retrieve restaurant availability - ${storeId}` }),
  });

  const rbiRestaurant = data?.restaurant;

  const isRestaurantPosOnline = checkAvailability((rbiRestaurant as unknown) as IRestaurant);

  return {
    isRestaurantPosOnline,
    loading,
    refetch,
  };
};
